import React from 'react';
import { InputOTP, InputOTPGroup, InputOTPSlot } from './InputOTP';

const OtpInput = ({ value, onChange, disabled, autoFocus = true, id }) => (
  <InputOTP id={id} maxLength={6} value={value} onChange={onChange} disabled={disabled} autoFocus={autoFocus}>
    <InputOTPGroup>
      <InputOTPSlot index={0} />
      <InputOTPSlot index={1} />
      <InputOTPSlot index={2} />
      <InputOTPSlot index={3} />
      <InputOTPSlot index={4} />
      <InputOTPSlot index={5} />
    </InputOTPGroup>
  </InputOTP>
);

export default OtpInput;
